import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { ButtonBase, Typography } from '@mui/material';
import { appColors } from '../assets/appColors';
export var TextWithEmbeddedButton = function (_a) {
    var text = _a.text, buttonText = _a.buttonText, onClick = _a.onClick, sx = _a.sx;
    var indexOfButton = text.indexOf(buttonText);
    var firstPart = text.slice(0, indexOfButton);
    var secondPart = text.slice(indexOfButton + buttonText.length);
    return (_jsxs(Typography, { sx: sx, children: [firstPart, _jsx(ButtonBase, { sx: embeddedButtonStyle, onClick: onClick, disableRipple: true, children: buttonText }), secondPart] }));
};
var embeddedButtonStyle = {
    color: appColors.color.navy2,
    fontFamily: 'inherit',
    fontSize: 'inherit',
    fontWeight: 700,
    verticalAlign: 'baseline',
};
